(function (global) {
  'use strict';

  var MAX_RATE_ATTEMPTS = 12;
  var RATE_POLL_INTERVAL = 350;

  function routeUrl(routeRoot, path) {
    var root = routeRoot || '/';
    if (!root.endsWith('/')) root += '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function parseRateName(label) {
    var value = String(label || '').trim();
    var match = value.match(/^(.*?)\s*(?:-|–|—)\s*((?:\d+\s*(?:a|-)\s*\d+|\d+)\s+dias?\s+úteis?)$/i);

    if (!match) {
      return {
        name: value,
        deliveryTime: 'Prazo informado no checkout',
      };
    }

    return {
      name: match[1].trim(),
      deliveryTime: match[2].trim(),
    };
  }

  function formatRatePrice(rate) {
    var amount = Number.parseFloat(rate && rate.price ? rate.price : '0');
    if (!Number.isFinite(amount) || amount === 0) return 'Grátis';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: (rate && rate.currency) || 'BRL',
    }).format(amount);
  }

  async function parseResponse(response) {
    var text = await response.text();
    if (!response.ok) {
      var error = new Error('Não foi possível consultar o frete.');
      error.responseBody = text;
      throw error;
    }
    return text && text !== 'null' ? JSON.parse(text) : null;
  }

  async function quoteShipping(options) {
    var fetcher = options.fetcher;
    var routeRoot = options.routeRoot || '/';
    var variantId = Number(options.variantId);
    var zip = String(options.zip || '').replace(/\D/g, '');
    var province = String(options.province || '');
    var wait = options.wait || function (milliseconds) {
      return new Promise(function (resolve) {
        setTimeout(resolve, milliseconds);
      });
    };

    if (!variantId || zip.length !== 8) {
      throw new Error('Produto ou CEP inválido para o cálculo de frete.');
    }

    var headers = { Accept: 'application/json' };
    var cartResponse = await fetcher(routeUrl(routeRoot, 'cart.js'), { headers: headers });
    var originalCart = await parseResponse(cartResponse);
    var temporaryLineKey = '';

    try {
      var addResponse = await fetcher(routeUrl(routeRoot, 'cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });
      var added = await parseResponse(addResponse);
      var addedLine = added && added.items ? added.items[0] : added;
      temporaryLineKey = addedLine && addedLine.key ? addedLine.key : '';

      if (!temporaryLineKey) {
        throw new Error('A Shopify não retornou o item usado na cotação.');
      }

      var address = new URLSearchParams();
      address.set('shipping_address[zip]', zip);
      address.set('shipping_address[country]', 'BR');
      address.set('shipping_address[province]', province);

      var prepareResponse = await fetcher(
        routeUrl(routeRoot, 'cart/prepare_shipping_rates.json') + '?' + address.toString(),
        {
          method: 'POST',
          headers: headers,
          body: '',
        }
      );
      await parseResponse(prepareResponse);

      for (var attempt = 0; attempt < MAX_RATE_ATTEMPTS; attempt += 1) {
        var ratesResponse = await fetcher(
          routeUrl(routeRoot, 'cart/async_shipping_rates.json') + '?' + address.toString(),
          { headers: headers }
        );
        var ratesPayload = await parseResponse(ratesResponse);

        if (ratesPayload && Array.isArray(ratesPayload.shipping_rates)) {
          return ratesPayload.shipping_rates;
        }

        await wait(RATE_POLL_INTERVAL);
      }

      throw new Error('O cálculo de frete excedeu o tempo de resposta.');
    } finally {
      if (temporaryLineKey) {
        var previousLine = (originalCart.items || []).find(function (item) {
          return item.key === temporaryLineKey;
        });
        var previousQuantity = previousLine ? previousLine.quantity : 0;

        var restoreResponse = await fetcher(routeUrl(routeRoot, 'cart/change.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: temporaryLineKey,
            quantity: previousQuantity,
          }),
        });
        await parseResponse(restoreResponse);
      }
    }
  }

  async function lookupZip(fetcher, zip) {
    var response = await fetcher('https://viacep.com.br/ws/' + zip + '/json/');
    if (!response.ok) throw new Error('Não foi possível consultar o CEP.');
    var address = await response.json();
    if (address.erro) throw new Error('CEP não encontrado.');
    return address;
  }

  function maskZip(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function findVariantId(box) {
    var scope = box.closest('product-information, .product-information, [data-product-information]') || document;
    var forms = Array.from(scope.querySelectorAll('form[action*="/cart/add"]'));
    var productForm = forms.find(function (form) {
      return form.querySelector('[name="id"]');
    });
    var selected = productForm && productForm.querySelector('[name="id"]');
    return Number(selected && selected.value ? selected.value : box.dataset.variantId);
  }

  function setMessage(box, message, isError) {
    var result = box.querySelector('.cep-resultado');
    result.textContent = message;
    result.classList.toggle('cep-error', Boolean(isError));
    result.classList.toggle('cep-success', !isError);
  }

  function renderRates(box, rates) {
    var tableWrap = box.querySelector('.frete-resultado');
    var tableBody = box.querySelector('[data-shipping-rates]');
    tableBody.textContent = '';

    rates.forEach(function (rate) {
      var parsed = parseRateName(rate.presentment_name || rate.name || rate.code);
      var row = document.createElement('tr');
      var nameCell = document.createElement('td');
      var timeCell = document.createElement('td');
      var priceCell = document.createElement('td');

      nameCell.textContent = parsed.name;
      timeCell.textContent = parsed.deliveryTime;
      priceCell.textContent = formatRatePrice(rate);
      nameCell.className = 'fc-service';
      priceCell.className = Number.parseFloat(rate.price || '0') === 0 ? 'fc-price fc-price--free' : 'fc-price';

      row.append(nameCell, timeCell, priceCell);
      tableBody.append(row);
    });

    tableWrap.hidden = false;
  }

  async function calculateForBox(box) {
    var input = box.querySelector('.campo-cep');
    var button = box.querySelector('.buscaCep');
    var tableWrap = box.querySelector('.frete-resultado');
    var zip = maskZip(input.value);
    input.value = zip;

    if (!/^\d{5}-\d{3}$/.test(zip)) {
      setMessage(box, 'Digite um CEP válido.', true);
      tableWrap.hidden = true;
      return;
    }

    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Calculando...';
    tableWrap.hidden = true;
    setMessage(box, '', false);

    try {
      var address;
      try {
        address = await lookupZip(global.fetch.bind(global), zip.replace(/\D/g, ''));
      } catch (zipError) {
        if (zipError.message === 'CEP não encontrado.') throw zipError;
        address = {};
      }

      var rates = await quoteShipping({
        fetcher: global.fetch.bind(global),
        routeRoot: global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/',
        variantId: findVariantId(box),
        zip: zip,
        province: address.uf || '',
      });

      if (!rates.length) {
        throw new Error('Não encontramos uma opção de entrega para este CEP.');
      }

      var location = [address.logradouro, address.localidade, address.uf].filter(Boolean).join(' - ');
      setMessage(box, location ? '⌖ ' + location : 'CEP ' + zip, false);
      renderRates(box, rates);
    } catch (error) {
      var knownMessage = /CEP não encontrado|Não encontramos uma opção/.test(error.message || '')
        ? error.message
        : 'Não foi possível calcular o frete agora. Tente novamente.';
      setMessage(box, knownMessage, true);
      tableWrap.hidden = true;
    } finally {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }

  function bindDocumentEvents() {
    if (global.__royalNativeShippingBound || typeof document === 'undefined') return;
    global.__royalNativeShippingBound = true;

    document.addEventListener('input', function (event) {
      var input = event.target.closest && event.target.closest('[data-royal-shipping] .campo-cep');
      if (input) input.value = maskZip(input.value);
    });

    document.addEventListener('keydown', function (event) {
      var input = event.target.closest && event.target.closest('[data-royal-shipping] .campo-cep');
      if (!input || event.key !== 'Enter') return;
      event.preventDefault();
      var box = input.closest('[data-royal-shipping]');
      if (box) calculateForBox(box);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-royal-shipping] .buscaCep');
      if (!button) return;
      var box = button.closest('[data-royal-shipping]');
      if (box) calculateForBox(box);
    });
  }

  var api = {
    bindDocumentEvents: bindDocumentEvents,
    calculateForBox: calculateForBox,
    formatRatePrice: formatRatePrice,
    maskZip: maskZip,
    parseRateName: parseRateName,
    quoteShipping: quoteShipping,
  };

  global.RoyalNativeShipping = api;
  bindDocumentEvents();
})(typeof window !== 'undefined' ? window : globalThis);
